import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/lib/utils";

const badgeVariants = cva(
  "inline-flex items-center rounded-md px-2 py-0.5 text-[11px] font-semibold leading-tight",
  {
    variants: {
      variant: {
        default: "bg-brand-50 text-brand-600",
        winner: "bg-accent-50 text-accent-700 border border-accent-500/20",
        category: "bg-slate-100 text-slate-600",
        success: "bg-green-50 text-green-700",
        error: "bg-red-50 text-red-700",
        warning: "bg-amber-50 text-amber-700",
        muted: "bg-slate-100 text-slate-500",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <span className={cn(badgeVariants({ variant }), className)} {...props} />
  );
}

export { Badge, badgeVariants };
